import PropTypes from 'prop-types';

// HoC
import { withStyles } from '@material-ui/core/styles';

// Utilities
import classNames from 'classnames';

// MuiComponents
import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/Error';

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  fullScreenRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    height: '100vh',
    flexDirection: 'column',
    background: 'rgba(55, 55, 55, 0.6)',
  },
  message: {
    padding: 15,
  },
  icon: {
    color: theme.palette.error.main,
  },
});

const FailureAlert = props => {
  const {
    message,
    messageProps = {},
    iconProps = {},
    className,
    classes,
    fullScreen = false,
  } = props;
  // Pull the className out to combine with our className
  const { className: messageClassName } = messageProps;
  let updatedMessageProps = { ...messageProps };
  delete updatedMessageProps.className;

  // Pull the className out to combine with our className
  const { className: iconClassName } = iconProps;
  let updatedIconProps = { ...iconProps };
  delete updatedIconProps.className;

  const rootClass = classNames(
    {
      [classes.root]: !fullScreen,
      [classes.fullScreenRoot]: fullScreen,
    },
    className,
  );

  return (
    <div className={rootClass} data-test-id={`FailureAlert-root`}>
      <ErrorIcon
        className={classNames(classes.icon, iconClassName)}
        {...iconProps}
      />
      <Typography
        className={classNames(classes.message, messageClassName)}
        variant={'caption'}
        data-test-id={`FailureAlert-message`}
        {...updatedMessageProps}
      >
        {message}
        {!message &&
          `Oops! We ran into an issue.  Please refresh and try again.  
          Or please contact our employee help desk for assistance: (818) 860-7756 or
          employeehelpdesk@castandcrew.com.  For Media Services assistance: (310) 254-1702 or crewportalhelp@mediaservices.com.`}
      </Typography>
    </div>
  );
};

FailureAlert.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
  messageProps: PropTypes.object,
  className: PropTypes.string,
};

export default withStyles(styles)(FailureAlert);
